const domain = 'a9nr9thoh';
const region = 'us-east-2';
const appClientId = '3up0pt9s6n5c4edcgbsl2aevjm';
const userPoolId = 'us-east-2_MLKLJO0l9';
const redirectURI = window.location.origin;
const logoutURI = window.location.origin;

export { domain, region, appClientId, userPoolId, redirectURI, logoutURI };
